export const TASKS = 'tasks';

export const TASK_ACTION_TYPES = {
  CREATE_TASK: `${TASKS}/CREATE_TASK`,
  RECEIVE_TASK: `${TASKS}/RECEIVE_TASK`,
  DELETE_TASK: `${TASKS}/DELETE_TASK`,
  RECEIVE_DELETED_TASK: `${TASKS}/RECEIVE_DELETED_TASK`,
  RECEIVE_TASKS: `${TASKS}/RECEIVE_TASKS`,
  FETCH_TASKS: `${TASKS}/FETCH_TASKS`,
  TOGGLE_TASK_COMPLETENESS: `${TASKS}/TOGGLE_TASK_COMPLETENESS`,
  RECEIVE_TOGGLED_TASK_COMPLETENESS: `${TASKS}/RECEIVE_TOGGLED_TASK_COMPLETENESS`,
  CREATE_SUBTASK: `${TASKS}/CREATE_SUBTASK`,
  RECEIVE_SUBTASK: `${TASKS}/RECEIVE_SUBTASK`,
  DELETE_SUBTASK: `${TASKS}/DELETE_SUBTASK`,
  RECEIVE_DELETED_SUBTASK: `${TASKS}/RECEIVE_DELETED_SUBTASK`,
  FETCH_SUBTASKS: `${TASKS}/FETCH_SUBTASKS`,
  RECEIVE_SUBTASKS: `${TASKS}/RECEIVE_SUBTASKS`,
  TOGGLE_SUBTASK_COMPLETENESS: `${TASKS}/TOGGLE_SUBTASK_COMPLETENESS`,
  RECEIVE_TOGGLED_SUBTASK_COMPLETENESS: `${TASKS}/RECEIVE_TOGGLED_SUBTASK_COMPLETENESS`
};



// WEBPACK FOOTER //
// ./src/redux/tasks/constants.js